<template>
    <v-dialog v-model="dialog" persistent max-width="290">
        <!-- <slot name="activator">
            <v-btn text slot="activator">{{ $t('screener.header.change.language.title') }}</v-btn>
        </slot> -->
        <v-list-tile-title slot="activator">{{ $t('screener.header.change.language.title') }}</v-list-tile-title>
        <v-card>
          <v-card-title class="subheading">
            {{ $t('screener.header.change.language.title') }}
            <v-spacer></v-spacer>
            <v-btn @click="dialog = false"  icon small>
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-list>
              <div v-for="locale in DEFINES.LOCALES" :key="locale.text">
                <v-list-tile @click="changeLocale(locale.value)">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ locale.text }} ({{ locale.value }})</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action v-if="locale.value == currentLanguage">
                    <v-icon color="success">mdi-check</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
              </div>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
    name: "ChangeLanguageDialog",
    data() {
        return {
            dialog: false
        }
    },
    computed: {
        ...mapGetters("app", {
            currentLanguage: "getCurrentLanguage",
        }),
    },
    methods: {
        async changeLocale(value) {
            await this.$store.dispatch("app/updateLocale", {
                locale: value,
            });
        },
    }
}
</script>
